'use es6';

import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import get from 'transmute/get';
import getIn from 'transmute/getIn';
import { createSelector } from 'reselect';
import EmailAddressPattern from 'PatternValidationJS/patterns/EmailAddress';
import { FORM_FIELD_TYPES } from 'MeetingsBase/constants/enums';
import { isEmpty, isWhitespace } from 'MeetingsLib/utils/utils';
var MAX_NAME_LENGTH = 45;

function validateEmail(email) {
  if (email && EmailAddressPattern.test(email)) {
    return false;
  }

  return I18n.text('prebook.details.errorHelper.email');
}

function validateFirstAndLastName(fieldValue) {
  var isEmptyString = fieldValue === null || fieldValue === undefined || isWhitespace(fieldValue) || isEmpty(fieldValue);

  if (isEmptyString) {
    return I18n.text('prebook.details.errorHelper.required');
  }

  if (fieldValue.length > MAX_NAME_LENGTH) {
    return I18n.text('prebook.details.errorHelper.tooLong');
  }

  return false;
}

function validateCustomFormFields(customFormFields, formFields) {
  if (!formFields || !formFields.size > 0) {
    return new ImmutableMap();
  }

  var customFormFieldValidation = customFormFields.reduce(function (acc, fieldValue, fieldName) {
    var field = formFields.find(function (formField) {
      return formField.name === fieldName;
    });

    if (!field) {
      return acc.set(fieldName, false);
    }

    var hasValue = fieldValue !== null && fieldValue !== undefined;

    if (field.fieldType === FORM_FIELD_TYPES.CHECKBOX || field.fieldType === FORM_FIELD_TYPES.ENUMERATION) {
      hasValue = hasValue && fieldValue.length > 0;
    }

    if (field.type === FORM_FIELD_TYPES.TEXT) {
      hasValue = hasValue && fieldValue !== '';
    }

    if (field.fieldType === FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      hasValue = hasValue && fieldValue !== false;
    }

    if (!hasValue && field.isRequired) {
      return acc.set(fieldName, I18n.text('prebook.details.errorHelper.required'));
    }

    return acc.set(fieldName, false);
  }, ImmutableMap());
  return customFormFieldValidation;
}

var VALIDATOR_MAP = new ImmutableMap({
  email: validateEmail,
  firstName: validateFirstAndLastName,
  lastName: validateFirstAndLastName,
  customFormFields: validateCustomFormFields
});
export var getInitialFormState = get('initialFormState');
export var getStagedFormState = get('stagedFormState');
export var getFormState = get('formState');
export var getCustomFormFields = createSelector([getStagedFormState], function (stagedFormState) {
  return stagedFormState.customFormFields;
});
export var getFormFields = getIn(['bookInfo', 'customParams', 'formFields']);

var getValidation = function getValidation(validatorMap, formStateGetter) {
  return createSelector([formStateGetter, getFormFields], function (formState, formFields) {
    if (!formState) {
      return false;
    }

    return validatorMap.reduce(function (validationErrors, validationFunction, fieldName) {
      var formValue = formState.get(fieldName);
      return validationErrors.set(fieldName, validationFunction(formValue, formFields));
    }, new ImmutableMap());
  });
};

export var getStagedFormFieldValidation = getValidation(VALIDATOR_MAP, getStagedFormState);
export var getFormFieldValidation = getValidation(VALIDATOR_MAP, getFormState);
export var getInitialFormFieldValidation = getValidation(VALIDATOR_MAP, getInitialFormState);